import React from 'react';
import { CallLogSummary } from '../../store/CallLogSlice';
import classes from './CallLog.module.css';
import './CallLog.module.css';

const CallLogCounts = (props: { subtotal: CallLogSummary[] | null }) => {
    if (props.subtotal != null && props.subtotal?.length > 0) {
        return (
            <div className="row card col-lg-5 col-md-6 col-xs-8 p-0 mb-2 mx-auto">
                <div className="col p-0">
                    <div className="col text-center"><span className={classes.resultHeader}></span></div>
                    <table className="table table-light table-sm table-striped table-hover mb-0 calllogcounts">
                        <caption className="resultHeader caption-top p-1 alert alert-info m-0">Calls by Category</caption>
                        <thead className={"bg-info text-white " + classes.tableHeader}>
                            <tr>
                                <th className={classes.col2Width}>
                                    Category
                                </th>
                                <th className="w-25 text-right pr-3">
                                    Total
                                </th>
                            </tr>
                        </thead>
                        <tbody className={classes.tableFont}>
                            {
                                props.subtotal.map((call: CallLogSummary) => (
                                    <tr key={call.categoryDescription}>
                                        <td data-label="Category">{call.categoryDescription}</td>
                                        <td data-label="Total" className="text-right pr-3">{call.totalRecords}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
    else {
        return <div></div>
    }
}

export default CallLogCounts;